import React, { Component } from 'react';

import sharedStyles from '../sharedStyles.scss';
import styles from './styles.scss';

class LeftRightTable extends Component {
  render() {
    const { subtitle, records, leftColumnTitle, rightColumnTitle } = this.props;

    return (
      <div className={sharedStyles.childLayout}>
        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        <div className={styles.tableLayout}>
          <div className={styles.tableHeader}>
            <div className={styles.tableLeftColumn}>{leftColumnTitle}</div>
            <div className={styles.tableRightColumn}>{rightColumnTitle}</div>
          </div>
          {records.map((record, i) => (
            <div key={i} className={styles.tableSection}>
              <div className={styles.tableLeftColumn}>{record.left}</div>
              <div className={styles.tableRightColumn}>{record.right}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default LeftRightTable;
